<template>
    <div ref="container" class="tw-relative tw-z-50">

      <button @click="isActive = !isActive"  class="tw-w-[40px] tw-h-[40px] tw-rounded-full tw-overflow-hidden tw-bg-primary-500 tw-border-2 tw-border-solid tw-border-primary-300 hover:tw-bg-primary-600 tw-duration-200">
        <img :src="$frontend('assets/images/avatars/avatar.png')" class="tw-w-full tw-h-full tw-object-cover" />
      </button>
  
      <transition
        class="tw-duration-200"
        enter-from-class="tw-translate-y-[10px]  tw-opacity-0"
        leave-to-class="tw-translate-y-[10px]  tw-opacity-0"
      >
        <div v-if="isActive">
          <div
            :class="[$root.$i18n.locale == 'ar' ? 'tw-left-0' : 'tw-right-0']"
            class="tw-w-fit tw-min-w-[200px] tw-shadow-md tw-max-w-[250px] tw-overflow-hidden tw-absolute -tw-bottom-1 tw-translate-y-full tw-bg-white tw-rounded-lg tw-border tw-border-b-2"
          >
            <div class="tw-w-full tw-pb-3">

              <div class="tw-w-full tw-mt-3">
                <router-link v-if="!['sponsor'].includes(authStore.user.role)" :to="{ name: 'pages.' + authStore.user.role + '.my-account' }" class="tw-flex tw-items-center tw-gap-2 tw-p-2 tw-px-5 hover:tw-bg-gray-50 tw-duration-200 tw-w-full">
                  <icon class="tw-text-xl tw-text-gray-500" icon="solar:user-circle-linear" />
                  <span class="tw-text-gray-500 tw-text-sm tw-font-medium">{{ $t('buttons.my-account') }}</span>
                </router-link>

                <router-link v-if="!['sponsor'].includes(authStore.user.role)" :to="{ name: 'pages.' + authStore.user.role + '.my-account' }" class="tw-flex tw-items-center tw-gap-2 tw-p-2 tw-px-5 hover:tw-bg-gray-50 tw-duration-200 tw-w-full">
                  <icon class="tw-text-xl tw-text-gray-500" icon="solar:buildings-2-linear" />
                  <span class="tw-text-gray-500 tw-text-sm tw-font-medium">{{ $t('buttons.my-companies') }}</span>
                </router-link>

                

                <router-link v-if="!['sponsor'].includes(authStore.user.role)" :to="{ name: 'pages.' + authStore.user.role + '.my-account' }" class="tw-flex tw-items-center tw-gap-2 tw-p-2 tw-px-5 hover:tw-bg-gray-50 tw-duration-200 tw-w-full">
                  <icon class="tw-text-xl tw-text-gray-500" icon="solar:users-group-rounded-linear" />
                  <span class="tw-text-gray-500 tw-text-sm tw-font-medium">{{ $t('buttons.my-contacts') }}</span>
                </router-link>

                <router-link v-if="!['sponsor'].includes(authStore.user.role)" :to="{ name: 'pages.' + authStore.user.role + '.my-account' }" class="tw-flex tw-items-center tw-gap-2 tw-p-2 tw-px-5 hover:tw-bg-gray-50 tw-duration-200 tw-w-full">
                  <icon class="tw-text-xl tw-text-gray-500" icon="solar:calendar-linear" />
                  <span class="tw-text-gray-500 tw-text-sm tw-font-medium">{{ $t('buttons.my-availability') }}</span>
                </router-link>

                
                
                

                <!-- Language Switcher Section -->
                <div class="tw-border-t tw-border-gray-100 tw-my-2"></div>
                
                <!-- Language Toggle Button -->
                <button
                  @click="toggleLanguageSection"
                  class="tw-flex tw-items-center tw-justify-between tw-gap-2 tw-p-2 tw-px-5 hover:tw-bg-gray-50 tw-duration-200 tw-w-full"
                >
                  <div class="tw-flex tw-items-center tw-gap-2">
                    <icon class="tw-text-xl tw-text-gray-500" icon="solar:earth-linear" />
                    <span class="tw-text-gray-500 tw-text-sm tw-font-medium">{{ $t('languages.language') }}</span>
                  </div>
                  <icon 
                    icon="solar:alt-arrow-down-linear" 
                    :class="[
                      'tw-text-xs tw-text-gray-400 tw-duration-200',
                      isLanguageSectionOpen && 'tw-rotate-180'
                    ]" 
                  />
                </button>

                <!-- Collapsible Language Options -->
                <div 
                  class="tw-grid tw-overflow-hidden tw-transition-all tw-duration-200 tw-ease-in-out"
                  :style="{                     gridTemplateRows: isLanguageSectionOpen ? '1fr' : '0fr'
                  }"
                >
                  <div class="tw-min-h-0">
                    <button
                      @click="changeLanguage('en')"
                      class="tw-flex tw-items-center tw-gap-2 tw-p-2 tw-px-5 hover:tw-bg-gray-50 tw-duration-200 tw-w-full tw-pl-8"
                    >
                      <icon class="tw-text-xl" icon="emojione-v1:flag-for-united-states" />
                      <span class="tw-text-gray-500 tw-text-sm tw-font-medium">{{ $t('languages.english') }}</span>
                    </button>

                    <button
                      @click="changeLanguage('fr')"
                      class="tw-flex tw-items-center tw-gap-2 tw-p-2 tw-px-5 hover:tw-bg-gray-50 tw-duration-200 tw-w-full tw-pl-8"
                    >
                      <icon class="tw-text-xl" icon="emojione-v1:flag-for-france" />
                      <span class="tw-text-gray-500 tw-text-sm tw-font-medium">{{ $t('languages.french') }}</span>
                    </button>

                    <button
                      @click="changeLanguage('es')"
                      class="tw-flex tw-items-center tw-gap-2 tw-p-2 tw-px-5 hover:tw-bg-gray-50 tw-duration-200 tw-w-full tw-pl-8"
                    >
                      <icon class="tw-text-xl" icon="emojione-v1:flag-for-spain" />
                      <span class="tw-text-gray-500 tw-text-sm tw-font-medium">{{ $t('languages.spanish') }}</span>
                    </button>

                    <button
                      @click="changeLanguage('pt')"
                      class="tw-flex tw-items-center tw-gap-2 tw-p-2 tw-px-5 hover:tw-bg-gray-50 tw-duration-200 tw-w-full tw-pl-8"
                    >
                      <icon class="tw-text-xl" icon="emojione-v1:flag-for-portugal" />
                      <span class="tw-text-gray-500 tw-text-sm tw-font-medium">{{ $t('languages.portuguese') }}</span>
                    </button>
                  </div>
                </div>

                <div class="tw-border-t tw-border-gray-100 tw-my-2"></div>

                <router-link v-if="false" :to="{ name: 'pages.' + authStore.user.role + '.my-account' }" class="tw-flex tw-items-center tw-gap-2 tw-p-2 tw-px-5 hover:tw-bg-gray-50 tw-duration-200 tw-w-full">
                  <icon class="tw-text-xl tw-text-gray-500" icon="solar:settings-linear" />
                  <span class="tw-text-gray-500 tw-text-sm tw-font-medium">{{ $t('buttons.settings') }}</span>
                </router-link>

                <router-link v-if="!['sponsor'].includes(authStore.user.role)" :to="{ name: 'pages.' + authStore.user.role + '.my-account' }" class="tw-flex tw-items-center tw-gap-2 tw-p-2 tw-px-5 hover:tw-bg-gray-50 tw-duration-200 tw-w-full">
                  <icon class="tw-text-xl tw-text-gray-500" icon="solar:help-linear" />
                  <span class="tw-text-gray-500 tw-text-sm tw-font-medium">{{ $t('buttons.help-desk') }}</span>
                </router-link>
  
                <button :disabled="isLogginOut" @click="handleLogout" 
                :class="[isLogginOut && '!tw-text-gray-300 !tw-bg-gray-50']"
                class="tw-flex tw-items-center tw-gap-2 tw-text-red-500 tw-p-2 tw-px-5 hover:tw-bg-gray-50 tw-duration-200 tw-w-full">
                  <icon class="tw-text-xl" :icon="isLogginOut ? 'line-md:loading-alt-loop' : 'solar:logout-3-linear'" />
                  <span class="tw-text-sm tw-font-medium">{{ $t('buttons.logout') }}</span>
                </button>
              </div>
            </div>
        </div>
        </div>
      </transition>
    </div>
  </template>
  
  <script setup>
  import { ref, computed } from "vue";
  import { onClickOutside } from "@vueuse/core";
  import { formatFullName } from '@/utils/string'
  import { useAuthStore } from "@/stores";
  import { useRouter } from "vue-router";
  import { logout } from '@/api/auth'
  import { saveInLocalStorage } from '@/utils/local-storage'
  import { useI18n } from 'vue-i18n'
  
  const isActive = ref(false);
  const isLanguageSectionOpen = ref(false);
  const container = ref(null);
  const authStore = useAuthStore();
  const router = useRouter();
  const isLogginOut = ref(false);
  const i18n = useI18n();
  
  const visibleName = computed(() => formatFullName(authStore.user.name));
  visibleName
  onClickOutside(container, () => (isActive.value = false));
  
  const toggleLanguageSection = () => {
    isLanguageSectionOpen.value = !isLanguageSectionOpen.value;
  }
  
  const changeLanguage = (languageCode) => {
    i18n.locale.value = languageCode;
    saveInLocalStorage('language', languageCode);
    isLanguageSectionOpen.value = false; // Close the language section after selection
  }
  
  const handleLogout = async () => {
    isLogginOut.value = true;
    await logout();
    
    authStore.logout();
    router.push({ name: 'auth.login' });
    isLogginOut.value = false;
  
  }
  </script>
  
  <style>
  </style>